<div class="row page-header">
    <div class="col-12">
        <h1>Auto Accident Report <small>Vehicle and equipment accident reporting</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Records</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-auto-accident-report-dashboard></app-auto-accident-report-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <app-auto-accident-reports></app-auto-accident-reports>
    </div>
</div>
